import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const profileDetails = createAsyncThunk('profile/details', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `user_profile`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateProfile = createAsyncThunk('profile/update', async (data) => {

    var bodyFormData = new FormData()

    bodyFormData.append(
        "id", data?.values?.id
    )
    bodyFormData.append(
        "first_name", data?.values?.first_name
    )
    bodyFormData.append(
        "last_name", data?.values?.last_name
    )
    bodyFormData.append(
        "gender", data?.values?.gender
    )
    bodyFormData.append(
        "username", data?.values?.username
    )
    bodyFormData.append(
        "email", data?.values?.email
    )
    bodyFormData.append(
        "dob", data?.values?.dob && moment(data?.values?.dob, 'DD/MM/YYYY').format('YYYY-MM-DD')
    )
    bodyFormData.append(
        "mobile_number", data?.values?.mobile_number
    )
    {
        data?.values?.profile &&
            bodyFormData.append(
                "user_profile", data?.values?.profile
            )
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_profile',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", 'type': 'profile', "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const changePassword = createAsyncThunk('profile/changePassword', async (data) => {

    try {
        const res = await axios({
            method: "PUT",
            url: getConfig.API_URL + 'change_password',
            data: {
                "old_password": data?.values?.old_password,
                "new_password": data?.values?.confirm_password,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const profile = createSlice({
    name: 'profile',
    initialState: {
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(profileDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });

    }
})

export default profile.reducer;